import { render } from "./Add.vue?vue&type=template&id=08e7dce4"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=08e7dce4&lang=css"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__